import React from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { toast } from 'react-hot-toast';

const PWAInstallButton = () => {
  const { isInstallable, isInstalled, installPWA } = usePWAInstall();

  const handleInstall = async () => {
    const installed = await installPWA();
    if (installed) {
      toast.success('Aplicativo instalado com sucesso!');
    } else {
      toast.error('Não foi possível instalar o aplicativo');
    }
  };

  // Não mostrar se já estiver instalado ou não for instalável
  if (isInstalled || !isInstallable) {
    return null;
  }

  return (
    <button
      onClick={handleInstall}
      className="fixed bottom-4 right-4 z-50 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2 transition-all duration-200 animate-bounce"
      aria-label="Instalar aplicativo"
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 14v-4M12 6v.01"
        />
      </svg>
      <span className="font-medium">Instalar App</span>
    </button>
  );
};

export default PWAInstallButton;

